<template>
  <section class="admin-content">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-home" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Health Facilities</h4>
              <small style="opacity: .8;">
                {{ Array.isArray(providers) ? providers.length : 0 }} registered facilities
              </small>
            </div>
            <div class="ml-auto d-flex" style="gap: 8px;">
              <button class="btn btn-light btn-sm font-weight-bold px-3" @click="showsearch = !showsearch">
                <i class="fe mr-1" :class="showsearch ? 'fe-x' : 'fe-filter'"></i>
                {{ showsearch ? 'Cancel' : 'Search Facility' }}
              </button>
              <button class="btn btn-light btn-sm font-weight-bold px-3" @click="show = !show">
                <i class="fe mr-1" :class="show ? 'fe-minus' : 'fe-plus'"></i>
                {{ show ? 'Cancel' : 'Add Facility' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">


        <!-- ── Stats / Export Controls ────────────────────────── -->
        <div class="card action-card shadow mb-4">
          <div class="card-body py-3 px-4">
            <div class="d-flex flex-wrap align-items-center" style="gap: 10px;">
              <button class="btn btn-sm btn-outline-primary" @click="getStats">
                <i class="fe fe-bar-chart-2 mr-1"></i> Get Statistics
              </button>
              <download-excel :data="stats" :fields="json_fields" class="btn btn-sm btn-outline-success"
                header="Health Facilty Data" :escapeCsv="false" name="Health Facilty Data">
                <i class="fe fe-file-text mr-1"></i> Export to CSV
              </download-excel>
            </div>
          </div>
        </div>

        <!-- ── Search Facility ─────────────────────────────────── -->
        <div v-show="showsearch" class="mb-4">
          <SearchProvider />
        </div>

        <!-- ── Filter Facility ─────────────────────────────────── -->
        <div v-show="showsearch" class="card shadow form-card mb-4">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-filter" style="font-size:13px;"></i></div>
            <h6 class="mb-0 font-weight-bold text-white">Filter Facility</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <div class="form-row">
              <div class="form-group col-md-4">
                <label class="small font-weight-bold text-secondary">Select Sector</label>
                <select class="form-control" v-model="register.sector">
                  <option :value="sector" v-for="sector in sectors" :key="sector">
                    {{ sector }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label class="small font-weight-bold text-secondary">Care Level</label>
                <select class="form-control" v-model="register.phc_type">
                  <option value="">All</option>
                  <option>Primary</option>
                  <option>Secondary</option>
                  <option>Tertiary</option>
                  <option value="Telemedicine">Telemedicine</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label class="small font-weight-bold text-secondary">Facility Type</label>
                <select class="form-control" v-model="register.phc_general">
                  <option value="">All</option>
                  <option>Public Hospital</option>
                  <option>Private Hospital</option>
                </select>
              </div>
            </div>
            <div class="d-flex justify-content-end" style="gap: 10px;">
              <button type="button" class="btn btn-outline-primary px-4" @click="getStats">
                <i class="fe fe-bar-chart-2 mr-1"></i> Get Statistics
              </button>
              <button type="button" class="btn btn-submit px-4" @click="getProviders">
                <i class="fe fe-filter mr-1"></i> Filter
              </button>
            </div>
          </div>
        </div>

        <!-- ── Add Facility Form ───────────────────────────────── -->
        <div v-show="show" class="card shadow form-card mb-4">
          <div class="form-card-header">
            <div class="section-number">1</div>
            <h6 class="mb-0 font-weight-bold text-white">Register New Health Facility</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">First Name</label>
                <input type="text" required class="form-control" placeholder="First Name"
                  v-model="register.firstname" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Last Name</label>
                <input type="text" required class="form-control" placeholder="Last Name"
                  v-model="register.lastname" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Agency Name</label>
                <input type="text" required class="form-control" placeholder="Agency Name"
                  v-model="register.agency_name" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Email</label>
                <input type="email" required class="form-control" placeholder="Email"
                  v-model="register.email" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Phone Number</label>
                <input v-phone type="text" required class="form-control" placeholder="Phone Number"
                  v-model="register.phone_number" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Address</label>
                <textarea class="form-control" rows="1" v-model="register.address1" placeholder="Address"></textarea>
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">LGA</label>
                <select class="form-control" v-model="register.localgovt" @change="fetchWards($event)">
                  <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                    {{ lga.local_name }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Ward</label>
                <select class="form-control" v-model="register.ward">
                  <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                    {{ ward.ward_name }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Sector</label>
                <select class="form-control" v-model="sector">
                  <option value="formal">Formal Sector</option>
                  <option value="informal">Informal Sector</option>
                </select>
              </div>
              <div class="form-group col-md-6" v-if="sector == 'informal'">
                <label class="small font-weight-bold text-secondary">Select Informal Sector</label>
                <select class="form-control" v-model="register.sector">
                  <option value="Vulnerable Groups">
                    Basic Healthcare Provision Fund
                  </option>
                  <option value="Oganized Private Sector Plan">
                    Oganized Private Sector Plan
                  </option>
                  <option value="Voluntary Contributor">
                    Voluntary Contributor
                  </option>
                  <option value="Organized Community Healthcare Plan">
                    Organized Community Healthcare Plan
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6" v-if="sector == 'formal'">
                <label class="small font-weight-bold text-secondary">Select Formal Sector</label>
                <select class="form-control" v-model="register.sector">
                  <option value="State Civil Servant Healthcare Plan">
                    State Civil Servant Healthcare Plan
                  </option>
                  <option value="LGA Civil Servant Healthcare Plan">
                    LGA Civil Servant Healthcare Plan
                  </option>
                  <option value="Universal Basic Education Board Healthcare Plan">
                    Universal Basic Education Board Healthcare Plan
                  </option>
                  <option value="State Pensioneers Healthcare Plan">
                    State Pensioneers Healthcare Plan
                  </option>
                  <option value="LGA Pensioneers Healthcare Plan">
                    LGA Pensioneers Healthcare Plan
                  </option>
                  <option value="Tertiary Student Health Insurance Plan (T-SHIP)">
                    Tertiary Student Health Insurance Plan (T-SHIP)
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Facility Type</label>
                <select class="form-control" v-model="register.phc_general">
                  <option>Public Hospital</option>
                  <option>Private Hospital</option>
                </select>
              </div>
              <div class="form-group col-12">
                <div class="custom-control custom-checkbox">
                  <input id="isTelemedicine" v-model="register.is_telemedicine" type="checkbox" class="custom-control-input" />
                  <label class="custom-control-label small" for="isTelemedicine">
                    Telemedicine provider (doctor / virtual practice; no enrollees are registered under it)
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end" style="gap: 10px;">
              <button type="button" class="btn btn-outline-secondary px-4" @click="show = false">
                Cancel
              </button>
              <button type="button" class="btn btn-submit px-5" @click="registerUser">
                <i class="fe fe-plus mr-2"></i> Add Health Facility
              </button>
            </div>
          </div>
        </div>

        <!-- ── Providers Table ────────────────────────────────── -->
        <div class="card shadow table-card">
          <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-3">
            <div>
              <h6 class="mb-0 font-weight-bold text-dark">
                <i class="fe fe-home text-primary mr-2"></i> Registered Providers
              </h6>
              <small class="text-muted">
                {{ Array.isArray(providers) ? providers.length : 0 }} facility(ies)
              </small>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th px-4">Name</th>
                  <th class="table-th">Email</th>
                  <th class="table-th">Contact</th>
                  <th class="table-th">Type</th>
                  <th class="table-th">Status</th>
                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="provider in providers" v-bind:key="provider.id" class="table-row">
                  <td class="px-4 py-3">
                    <router-link :to="{ path: '/provider-' + provider.id }" class="font-weight-bold" style="font-size:.88rem;">
                      {{ provider.agency_name }}
                    </router-link>
                    <button type="button" class="btn btn-sm btn-link p-0 ml-1 text-muted" @click="copyText(provider)" title="Copy name">
                      <i class="fe fe-copy" style="font-size:.8rem;"></i>
                    </button>
                  </td>
                  <td class="py-3" style="font-size:.88rem;">{{ provider.email }}</td>
                  <td class="py-3" style="font-size:.88rem;">{{ provider.phone_number }}</td>
                  <td class="py-3">
                    <span class="rel-chip">{{ provider.phc_general }}</span>
                  </td>
                  <td class="py-3">
                    <span v-if="provider.status == 1" class="status-badge status-badge--approved">approved</span>
                    <span v-if="provider.status == 0" class="status-badge status-badge--pending">pending</span>
                  </td>
                  <td class="py-3">
                    <router-link :to="{ path: '/provider-' + provider.id }">
                      <button type="button" class="btn btn-sm btn-outline-primary">
                        <i class="fe fe-eye mr-1"></i> View
                      </button>
                    </router-link>
                  </td>
                </tr>
                <tr v-if="!providers || providers.length === 0">
                  <td colspan="6" class="text-center text-muted py-5">
                    <i class="fe fe-home" style="font-size:2rem;display:block;margin-bottom:8px;"></i>
                    No providers found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
      <FacilityDuplicateModal :matches="duplicates.matches" :likely="duplicates.likely" :name="register.agency_name" :busy="linking"
        @cancel="duplicates = { matches: [], likely: 0 }" @add-anyway="addAnyway" @link="linkExisting" />
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import FacilityDuplicateModal from "./FacilityDuplicateModal.vue";
  import SearchProvider from "@/views/providers/SearchProvider.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin

  export default {
    components: { FacilityDuplicateModal,
      Navbar,
      Loading,
      SearchProvider,
    },
    data() {
      return {
      isAgencyStaff: ["shis", "employee"].includes((JSON.parse(localStorage.getItem("user") || "{}") || {}).type),
      duplicates: { matches: [], likely: 0 },
      linking: false,
        sectors: [
        "Basic Healthcare Provision Fund",
        "State Equity Program",
        "Voluntary Contributor",
        "State Civil Servant",
        "State Public Servant",
        "LGA Civil Servant",
        "Organized Private Sector",
        "T-SHIP",
        "State Pensioners Plan",
        "LGA Pensioners Plan",
      ],
        user: null,
        providers: "",
        agencies: "",
        edit: false,
        show: false,
        showsearch: false,
        isLoading: false,
        fullPage: true,
        agency_id: "",
        provider_id: "",
        states: "",
        state: "",
        lga_states: "",
        sector: "",
        wards: [],
        stats: "",
        json_fields: {
          Name: "agency_name",
          "Total Principal ": "enrollees_count",
          "Male Total": "male_count",
          "female Total": "female_count",
          "Dependent Count": "dependants_count",
          Total: "total",
        },
        json_meta: [
          [
            {
              key: "charset",
              value: "utf-8",
            },
          ],
        ],
        register: {
          is_telemedicine: false,
          firstname: "Nil",
          lastname: "Nil",
          facility_code: "",
          email: "",
          type: "provider",
          phone_number: "No Number Provided",
          state: "",
          agency_name: "",
          ward: "",
          services_offered: "",
          localgovt: "",
          sector: "",
          address1: "",
          role: 0,
          phc_general: "",
          password: "euhler",
          password_confirmation: "euhler",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/providerAgency/90`)
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    methods: {
      copyText(provider) {
        const copyToClipboard = (provider) =>
          navigator.clipboard.writeText(provider.agency_name);
        copyToClipboard(provider);
        this.$toasted.info("Copied to clipboard", {
          position: "top-center",
          duration: 3000,
        });
      },
      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/2669`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      // Checks the state for likely duplicates first; the dialog lets staff open/link the existing one or add anyway.
      registerUser() {
        if (!this.register.agency_name) return this.doRegister();
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/providers/duplicate-check", {
            agency_name: this.register.agency_name,
            facility_code: this.register.facility_code,
            phone_number: this.register.phone_number,
            email: this.register.email,
            localgovt: this.register.localgovt,
            ward: this.register.ward,
          })
          .then((res) => {
            this.isLoading = false;
            if (res.data.matches && res.data.matches.length) {
              this.duplicates = res.data;
            } else {
              this.doRegister();
            }
          })
          .catch(() => { this.isLoading = false; this.doRegister(); }); // the check never blocks adding
      },
      addAnyway() {
        this.duplicates = { matches: [], likely: 0 };
        this.doRegister();
      },
      linkExisting(m) {
        this.linking = true;
        this.axios
          .post("/api/v1/auth/providerApply", { provider_id: m.id, agency_id: 90, status: true })
          .then(() => {
            this.$toasted.success(`${m.agency_name} is now linked to your agency.`, { position: "top-center", duration: 5000 });
            this.duplicates = { matches: [], likely: 0 };
            this.show = false;
            this.getProviders();
          })
          .catch(() => this.$toasted.error("Could not link the facility.", { position: "top-center", duration: 4000 }))
          .finally(() => { this.linking = false; });
      },
      doRegister() {
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            firstname: this.register.firstname,
            lastname: this.register.lastname,
            facility_code: this.register.facility_code,
            email: this.register.email,
            phone_number: this.register.phone_number,
            agency_name: this.register.agency_name,
            type: this.register.type,
            state: "2669",
            localgovt: this.register.localgovt,
            services_offered: this.register.services_offered,
            address1: this.register.address1,
            ward: this.register.ward,
            enrolled_by: this.user.id,
            user_role: this.register.role,
            org_id: 10,
            password: this.register.password,
            password_confirmation: this.register.password_confirmation,
            phc_sector: this.sector,
            // Telemedicine providers are marked by phc_type (TelemedicineAccess::PHC_TYPE in the API).
            phc_type: this.register.is_telemedicine ? "Telemedicine" : this.register.sector,
            phc_general: this.register.phc_general,
          })
          .then((response) => {
            let user_id = response.data.data.id;

            //add provider
            this.show = false;
            //   console.log(user_id)
            this.axios
              .post("/api/v1/auth/providerApply", {
                provider_id: user_id,
                agency_id: 90,
                status: true,
              })

              .then((response) => {
                console.log(response);
                this.$toasted.info("Provider added Successfully!", {
                  position: "top-left",
                  duration: 5000,
                });
                this.$router.push(`/provider-${user_id}`);
              })
              .catch((error) => {
                console.log(error.response);
              });
            //end of provider

            console.log(response);
            this.isLoading = false;
            // localStorage.setItem('jwt',token);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$toasted.error("Sign up not Successful", {
              position: "top-left",
              duration: 5000,
            });
          });
      },
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgency/90`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/` + event.target.value)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response.data.data);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getStats() {
        this.isLoading = true;

        this.axios
          .get(`/api/v1/auth/provider/stats`, {
            params: {
              agency_id: 90,
              sector: this.register.sector,
            },
          })
          .then((response) => {
            this.stats = response.data.data;
            console.log(response);
            this.isLoading = false;

            this.stats = response.data.data.filter((item) => item.total > 0);

            this.$toasted.info("Fetched Successfully!", {
              position: "top-left",
              duration: 5000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      },

      clearIt() {
        this.agency_id = "";
      },
    },
    created() {
      // the Providers menu links here with ?add=1 (?add=telemedicine) to open the add form
      if (this.$route.query.add) { this.show = true; if (this.$route.query.add === "telemedicine") this.register.sector = "Telemedicine"; }
      this.fetchLga();
    },
  };
</script>

<style scoped>
  .page-header {
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
    padding-bottom: 60px;
  }

  .container.mt-n3 {
    margin-top: -32px !important;
  }

  .header-icon-wrap {
    width: 52px;
    height: 52px;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .action-card {
    border-radius: 14px !important;
    border: none !important;
  }

  .form-card {
    border-radius: 14px !important;
    border: none !important;
    overflow: hidden;
  }

  .form-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    background: linear-gradient(135deg, #1e3a5f, #2563eb);
  }

  .section-number {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .btn-submit {
    background: linear-gradient(135deg, #2563eb, #7c3aed) !important;
    color: #fff !important;
    border: none !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
  }

  .btn-submit:hover {
    opacity: 0.92;
    color: #fff !important;
  }

  .table-card {
    border-radius: 14px !important;
    border: none !important;
    overflow: hidden;
  }

  .table-head {
    background: #f8fafc;
  }

  .table-th {
    font-size: 0.75rem !important;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b !important;
    font-weight: 600 !important;
    border-bottom: 2px solid #e2e8f0 !important;
    padding: 12px 16px !important;
    white-space: nowrap;
  }

  .table-row {
    border-color: #f1f5f9 !important;
    transition: background 0.15s;
  }

  .table-row:hover {
    background: #f8fafc !important;
  }

  .rel-chip {
    display: inline-block;
    background: #eff6ff;
    color: #2563eb;
    font-size: 0.7rem;
    padding: 1px 7px;
    border-radius: 10px;
    font-weight: 600;
  }

  .status-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
  }

  .status-badge--pending  { background: #fff7ed; color: #c2410c; }
  .status-badge--approved { background: #f0fdf4; color: #15803d; }
</style>
